import app from '../app';

class CartService {

    /*@ngInject*/
    constructor(apiService, errorsService, cartPreview, cart, toastr, $window, $uibModal) {
        this.apiService = apiService;
        this.errorsService = errorsService;
        this.cartPreview = cartPreview;
        this.cart = cart;
        this.toastr = toastr;
        this.window = $window;
        this.uibModal = $uibModal;
    }

    getCartPreview() {
        return this.cartPreview;
    }

    getCart() {
        return this.cart;
    }

    updatePaymentMethod(paymentMethod) {
        return this.apiService.updateCartPaymentMethod(paymentMethod)
            .then((data) => data);
    }

    handleException(exception) {
        if (typeof exception.data !== 'undefined') {
            switch (exception.status) {
                case 404:
                case 412:
                    this.toastr.warning(exception.data.message);
                    break;
                case 403:
                case 500:
                    this.toastr.error(exception.data.message);
                    break;
                default:
                    this.toastr.info(exception.data.message);
                    break;
            }
            this.errorsService.errorCallback(exception.data.message);
        }
    }

    addItem(productId, quantity) {
        return this.apiService.addToCart(productId, quantity)
            .then(data => {
                this.updateCartModel(data);
                return Promise.resolve(data);
            })
            .catch(exception => {
                this.handleException(exception);
                return Promise.reject(exception);
            });
    }

    addBooklistItems(booklistId) {
        return this.apiService.addBooklistItemsToCart(booklistId)
            .then(data => {
                let addedItemsCount = data.bookListProducts.length;
                if (typeof data.errors !== 'undefined' && data.errors.length > 0) {
                    this.promptAddToCartErrors(data.errors.join("</br>"));
                    addedItemsCount = data.bookListProducts.length - data.errors.length;
                }
                if(addedItemsCount > 0){
                    this.toastr.success(addedItemsCount + " Items added to cart");
                }
                this.window.scrollTo(0, 0);
                this.updateCartModel(data);
                return Promise.resolve(data);
            })
            .catch(exception => {
                this.handleException(exception);
                return exception;
            });
    }

    promptAddToCartErrors(message) {
        let modalInstance = this.uibModal.open({
            template: require('../layout/modal/messages.modal.html'),
            controller: 'MessagesModalController',
            controllerAs: 'vm',
            bindToController: true,
            resolve: {
                messageHtml: () => { return message; },
                messageSubject: () => { return '<span class="fa fa-warning"></span> Notification'; }
            }
        });

        return modalInstance.result.then((result) => {

        });
    }

    updateItem(item) {
        return this.apiService.updateCartItem(item.id, {quantity: item.quantity})
            .then(data => {
            });
    }

    removeItem(itemId) {
        return this.apiService.removeCartItem(itemId)
            .then(data => {
                this.updateCartModel(data);
            });
    }

    removeItems() {
        return this.apiService.clearCart()
            .then(data => {
                this.updateCartModel(data);
            });
    }

    updateCartModel(data) {
        if (typeof data.cart != 'undefined') {
            this.cart = data.cart;
        }
        if (typeof data.cartPreview != 'undefined') {
            this.cartPreview = data.cartPreview;
        }
    }

}

app.service("cartService", CartService);


// WEBPACK FOOTER //
// ./static/js/app/services/cart.service.js